// src/api.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://apibe.iduuka.com/",
});

export const assetUrl = (path) =>
  path ? `${process.env.REACT_APP_API_URL}${path}` : null;

export default api;
